export default __webpack_public_path__ + "static/media/undraw_video_influencer_-9-oyy.3fb57e8a.svg";